import React from "react";
import Listings from "../components/Listings";

const Homes = () => {
  return <Listings />;
};

export default Homes;
